const normalizeJobPostingErrorText = (value) => String(value || '').trim();

const lowerJobPostingErrorText = (value) =>
  normalizeJobPostingErrorText(value)
    .toLowerCase()
    .replace(/\s+/g, ' ');

export const isGenericJobPostingErrorMessage = (value) => {
  const normalized = lowerJobPostingErrorText(value);

  if (!normalized) return true;

  return [
    'payment required',
    'payment_required',
    'posting_failed',
    'button_not_found',
    'buttons_not_found',
    'failed to post job',
    'failed to post job on linkedin',
    'failed to post job on naukri',
    'job posting failed',
    'job posting could not be completed',
    'could not complete the posting process',
    'free_job_limit_reached',
  ].includes(normalized);
};

export const formatJobPostingErrorMessage = (rawMessage, { platform, detail } = {}) => {
  const message = normalizeJobPostingErrorText(rawMessage);
  const detailText = normalizeJobPostingErrorText(detail);
  const normalizedMessage = lowerJobPostingErrorText(message);
  const normalizedDetail = lowerJobPostingErrorText(detailText);
  const platformLabel =
    platform ||
    (/linkedin/.test(`${normalizedMessage} ${normalizedDetail}`)
      ? 'LinkedIn'
      : /naukri/.test(`${normalizedMessage} ${normalizedDetail}`)
      ? 'Naukri'
      : 'The platform');

  if (!message && !detailText) {
    return 'Job posting could not be completed. Please review the posting log and try again.';
  }

  if (normalizedMessage === 'buttons_not_found' || normalizedDetail === 'buttons_not_found') {
    return `${platformLabel} could not find the publish controls. Please review the posting log and try reposting.`;
  }

  if (normalizedMessage === 'posting_failed' || normalizedDetail === 'posting_failed') {
    return `${platformLabel} job posting could not be completed. Please review the posting log and try reposting.`;
  }

  if (normalizedMessage === 'button_not_found' || normalizedDetail === 'button_not_found') {
    return `${platformLabel} could not find a required button while posting. Please review the posting log and try again.`;
  }

  const effectiveDetail = detailText || message;
  const effectiveNormalized = normalizedDetail || normalizedMessage;

  if (
    effectiveNormalized === 'payment required' ||
    effectiveNormalized === 'payment_required' ||
    effectiveNormalized.startsWith('payment required:') ||
    effectiveNormalized.includes('payment method') ||
    effectiveNormalized.includes('requires payment') ||
    effectiveNormalized.includes('need payment')
  ) {
    const cleanedDetail = effectiveDetail
      .replace(/^payment required:\s*/i, '')
      .replace(/_/g, ' ')
      .trim();

    if (cleanedDetail && lowerJobPostingErrorText(cleanedDetail) !== 'payment required') {
      return `${platformLabel} requires payment before this job can be published. ${cleanedDetail}`;
    }

    return `${platformLabel} requires payment before this job can be published. Add a payment method or use a paid posting option on this recruiter account, then repost.`;
  }

  if (
    effectiveNormalized.includes('active free job limit reached') ||
    effectiveNormalized.includes("don't have access to post job") ||
    effectiveNormalized.includes('do not have access to post job') ||
    effectiveNormalized.includes('free_job_limit_reached') ||
    effectiveNormalized.includes('free job limit reached')
  ) {
    return `${platformLabel} cannot publish this job because the recruiter account has reached its active free job limit. Close an existing free job or switch to a paid posting plan, then repost.`;
  }

  return effectiveDetail.replace(/_/g, ' ');
};
